import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import to from 'await-catch'
import {
	TableContainer,
	GridTable,
	EmptyStateContainer,
	GridHeader,
	GridHeaderCell,
	GridRow,
	GridCell,
	DownloadLinkContainer,
	DownloadLink,
} from './styled'
import { Download, SadFace, ArrowDouble, Arrows, Loader, Edit, Trash, ChevronRight } from '../../assets/icons'
import { Text1, Text2 } from '../ui/text'
import { Button } from '../ui/button'
import theme from '../../styled/theme'
import ModalOrderDetail from '../ModalOrderDetail'
import { resetLabsFilters } from '../../actions/filterLaboratory'
import { downloadExamResult } from '../../api'
import { IconContainer } from '../quickAceesCard/styled'
import { Container } from '../homeDashBoard/styled'
import styled from 'styled-components'
import EmptyState from '../emptyState'

const ResultsListDesk = ({
	results,
	isSearch = false,
	resetLabsFilters,
	headers,
	enableSorting = false,
	handleDownloadArancel,
	handleSort,
	useCheckboxes = false,
	getSelectedItems,
	onEditUser = undefined,
	onBlankUser = undefined,
	onDeleteUser = undefined,
	searchWasMade = true,
	showResetButton = true,
	emptyStateTitle = "No se encontraron resultados",
	emptyStateSubtitle = "Probá con otra búsqueda o volvé a intentarlo más tarde.",
	style
}) => {
	const location = useLocation()
	const hasResults = results ? results?.length > 0 || results.length > 0 : false
	const [sortState, setSortState] = useState({ key: '', order: 'none' })
	const [selectedRows, setSelectedRows] = useState({})
	const [selectedOrder, setSelectedOrder] = useState(null)

	let defaultHeaders

	if (location.pathname.includes('/usuarios')) {
		defaultHeaders = [
			{ label: 'Nombre y apellido', key: 'user' },
			{ label: 'Email', key: 'email' },
			{
				label: 'Roles', key: 'roles', render: row => (
					<RoleBadge key={row.key}>{row.roles || '-'}</RoleBadge>
				)
			},
			{ label: 'Empresa', key: 'empresa' },
			{
				label: 'Acciones',
				key: 'acciones',
				render: row => (
					<Container style={{ display: 'flex', flexDirection: 'row', gap: '12px', cursor: 'pointer' }}>
						<IconContainer onClick={() => onBlankUser?.(row)}>
							<Loader color={theme.colors.brand.blueOmint} />
							<Text1 color={theme.colors.brand.blueOmint} size={'14px'} textDecoration={'underline'}>
								Blanquear
							</Text1>
						</IconContainer>
						<IconContainer onClick={() => onEditUser?.(row)}>
							<Edit color={theme.colors.brand.blueOmint} />
							<Text1 color={theme.colors.brand.blueOmint} size={'14px'} textDecoration={'underline'}>
								Editar
							</Text1>
						</IconContainer>
						<IconContainer onClick={() => onDeleteUser?.(row)}>
							<Trash color={theme.colors.brand.blueOmint} />
							<Text1 color={theme.colors.brand.blueOmint} size={'14px'} textDecoration={'underline'}>
								Borrar
							</Text1>
						</IconContainer>
					</Container>
				)
			}
		]
	} else if (location.pathname.includes('/aranceles')) {
		defaultHeaders = [
			{ label: 'Fecha de vigencia', key: 'fechaVigencia', icon: <ArrowDouble /> },
			{ label: 'Clínica', key: 'clinica', icon: <ArrowDouble /> },
			{ label: 'Observaciones', key: 'observaciones', icon: <ArrowDouble /> },
			{
				label: 'Descargas',
				key: 'descargas',
				render: row => (
					<Container style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
						<IconContainer
							onClick={() =>
								handleDownloadArancel
									? handleDownloadArancel(row, 'pdf')
									: console.log('Descargar arancel PDF', row)
							}
						>
							<Download color={theme.colors.brand.blueOmint} />
							<Text1
								color={theme.colors.brand.blueOmint}
								size={'14px'}
								style={{ textDecoration: 'underline', cursor: 'pointer' }}
							>
								PDF
							</Text1>
						</IconContainer>
						<IconContainer
							onClick={() =>
								handleDownloadArancel
									? handleDownloadArancel(row, 'xls')
									: console.log('Descargar arancel XLS', row)
							}
						>
							<Download color={theme.colors.brand.blueOmint} />
							<Text1
								color={theme.colors.brand.blueOmint}
								size={'14px'}
								style={{ textDecoration: 'underline', cursor: 'pointer' }}
							>
								XLS
							</Text1>
						</IconContainer>
					</Container>
				)
			}
		]
	} else if (location.pathname.includes('/logs')) {
		defaultHeaders = [
			{ label: 'Usuario', key: 'nombreApellidoUsuario' },
			{ label: 'Email', key: 'emailUsuario' },
			{ label: 'Fecha', key: 'fechaHora' },
			{ label: 'Acción', key: 'nombreAccion' },
			{ label: 'Log', key: 'descripcion' },
		]
	} else if (location.pathname.includes('/facturacion')) {
		defaultHeaders = [
			{ label: 'N° Factura', key: 'factura', icon: <ArrowDouble /> },
			{ label: 'Fecha', key: 'fecha', icon: <ArrowDouble /> },
			{ label: 'Importe', key: 'importe', icon: <ArrowDouble /> },
			{
				label: 'Acciones', key: 'acciones', render: row => (
					<Container style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
						<IconContainer
							onClick={() =>
								handleDownloadArancel
									? handleDownloadArancel(row, 'pdf')
									: console.log('Descargar arancel PDF', row)
							}
						>
							<Download color={theme.colors.brand.blueOmint} />
							<Text1
								color={theme.colors.brand.blueOmint}
								size={'14px'}
								style={{ textDecoration: 'underline', cursor: 'pointer' }}
							>
								PDF
							</Text1>
						</IconContainer>

					</Container>
				)
			}
		]
	} else if (location.pathname.includes('/pacientes-internados')) {
		defaultHeaders = [
			{ label: 'N° Afiliado', key: 'numAfiliado', sortable: true },
			{ label: 'Paciente', key: 'nombre', sortable: true },
			{ label: 'Ingreso', key: 'fechaIngreso', sortable: true },
			{ label: 'Egreso', key: 'fechaEgreso', sortable: true },
			{ label: 'Clínica', key: 'clinica', sortable: true },
			{ label: 'Área', key: 'area', sortable: true },
			{ label: 'Habitación', key: 'habitacion', sortable: true },
			{ label: 'Cama', key: 'cama', sortable: true },
			{ label: 'Condición de Ingreso', key: 'condicionIngreso', sortable: true },
			{ label: 'Diagnóstico de Ingreso', key: 'diagnosticoIngreso', sortable: true },
		]
	} else {
		defaultHeaders = [
			{ label: 'Fecha de informe', key: 'fecha' },
			{ label: 'Número de orden', key: 'orden' },
			{ label: 'Clínica', key: 'clinica' },
			{ label: 'Informe', key: 'informe' }
		]
	}

	const tableHeaders = headers || defaultHeaders

	const gridTemplateColumns = [
		...(useCheckboxes ? ['1fr'] : []),
		...tableHeaders.map(header => header.width || '1fr')
	].join(' ')

	const isHeaderSortable = header => {
		if (!handleSort || !header?.key) return false
		if (typeof header.sortable === 'boolean') return header.sortable
		return enableSorting
	}

	const rowsWithKeys = useMemo(
		() =>
			(results || []).map((result, index) => ({
				...result,
				_tableRowKey: result.id || result.numeroComprobante || result.numeroFactura || index
			})),
		[results]
	)

	useEffect(() => {
		setSelectedRows({})
	}, [results])

	useEffect(() => {
		if (!getSelectedItems) return

		const selectedItems = rowsWithKeys.filter(result => selectedRows[result._tableRowKey])
		getSelectedItems(selectedItems)
	}, [selectedRows, rowsWithKeys, getSelectedItems])

	const onHeaderSort = key => {
		if (!handleSort || !key) return

		const nextOrder =
			sortState.key === key ? (sortState.order === 'asc' ? 'desc' : 'asc') : 'asc'

		setSortState({ key, order: nextOrder })
		handleSort(key, nextOrder)
	}

	const allRowsSelected = rowsWithKeys.length > 0 && rowsWithKeys.every(row => selectedRows[row._tableRowKey])

	const toggleAllRows = () => {
		if (allRowsSelected) {
			setSelectedRows({})
			return
		}

		const nextSelected = rowsWithKeys.reduce((accumulator, row) => {
			accumulator[row._tableRowKey] = true
			return accumulator
		}, {})

		setSelectedRows(nextSelected)
	}

	const toggleRowSelection = rowKey => {
		setSelectedRows(previous => ({
			...previous,
			[rowKey]: !previous[rowKey]
		}))
	}

	const handleDownload = async (e, result) => {
		e.preventDefault()
		const request = { actId: result.actId }
		const [err, { data } = {}] = await to(downloadExamResult(request))
		if (!err && data) {
			const link = document.createElement('a')
			link.href = data
			link.target = '_blank'
			link.click()
		}
	}

	return (
		<TableContainer style={style}>
			<GridTable>
				<GridHeader $gridTemplateColumns={gridTemplateColumns}>
					{useCheckboxes && (
						<GridHeaderCell>
							<SelectionCheckbox
								type="checkbox"
								checked={allRowsSelected}
								onChange={toggleAllRows}
							/>
						</GridHeaderCell>
					)}
					{tableHeaders.map(header => (
						<GridHeaderCell
							key={header.key}
							onClick={() => isHeaderSortable(header) && onHeaderSort(header.key)}
							style={{ cursor: isHeaderSortable(header) ? 'pointer' : 'default' }}
						>
							{header.label}
							{(header.icon || isHeaderSortable(header)) && (
								<span
									onClick={e => {
										e.stopPropagation()
										onHeaderSort(header.key)
									}}
									style={{ marginRight: 6, cursor: 'pointer' }}
								>
									{header.icon || (
										<Arrows
											direction={sortState.key === header.key ? sortState.order : 'none'}
											activeColor={theme.colors.brand.blueOmint}
											inactiveColor={'#9CA3AF'}
										/>
									)}
								</span>
							)}
						</GridHeaderCell>
					))}
				</GridHeader>
				{hasResults ? (
					rowsWithKeys.map(result => (
						<GridRow key={result._tableRowKey} $gridTemplateColumns={gridTemplateColumns}>
							{useCheckboxes && (
								<GridCell>
									<SelectionCheckbox
										type="checkbox"
										checked={!!selectedRows[result._tableRowKey]}
										onChange={() => toggleRowSelection(result._tableRowKey)}
									/>
								</GridCell>
							)}
							{tableHeaders.map(header => (
								<GridCell key={header.key}>
									{header.render ? (
										header.render(result)
									) : header.key === 'info' ? (
										<DownloadLinkContainer
											as="div"
											style={{ cursor: 'pointer' }}
											onClick={() => setSelectedOrder(result)}
										>
											<DownloadLink as="span">Ver más</DownloadLink>
											<ChevronRight  size={10} color={theme.colors.brand.blueOmint} />
										</DownloadLinkContainer>
									) : header.key === 'descargas' || header.key === 'informe' ? (
										<DownloadLinkContainer onClick={e => handleDownload(e, result)}>
											<Download />
											<DownloadLink href="#">Descargar</DownloadLink>{' '}
										</DownloadLinkContainer>
									) : (
										result[header.key]
									)}
								</GridCell>
							))}
						</GridRow>
					))
				) : searchWasMade ? (
					<EmptyStateContainer>
						<EmptyState actionButton={showResetButton ? resetLabsFilters : false} isSearch={isSearch} title={emptyStateTitle} subtitle={emptyStateSubtitle}/>
					</EmptyStateContainer>
				) : null}
			</GridTable>
			{selectedOrder && (
				<ModalOrderDetail order={selectedOrder} onClose={() => setSelectedOrder(null)} />
			)}
		</TableContainer>
	)
}

const RoleBadge = styled.span`
	align-self: flex-start;
	padding: 6px 10px;
	border-radius: 999px;
	background: ${props => props.theme.colors.brand.backgroundBlue};
	color: ${props => props.theme.colors.brand.lightBlue};
	font-size: 14px;
	font-weight: 500;
`

const SelectionCheckbox = styled.input`
	accent-color: ${props => props.theme.colors.brand.blueOmint};
`

export default connect(null, { resetLabsFilters })(React.memo(ResultsListDesk))
